<bgo-faq-accordion [questions]="questions">
  @for (element of elements; track element) {
    <cft-accordion-element [title]="element.title" whitespace="sm">
      @if (element.content) {
        <bgo-rich-text [content]="element.content"></bgo-rich-text>
      }
    </cft-accordion-element>
  }
</bgo-faq-accordion>
